import type { MapDispatchToProps, ThunkAction, Dispatch } from 'types/redux';

export interface MobileOptimizedTeaserDispatchProps {
  openEditorModePanel: () => void;
}

const getEditorAPI: ThunkAction = (
  dispatch,
  getState,
  { editorAPI, host },
) => ({
  editorAPI,
  state: getState(),
  host,
});

export const mapDispatchToProps: MapDispatchToProps<
  MobileOptimizedTeaserDispatchProps,
  {}
> = (dispatch: Dispatch) => {
  const { editorAPI } = dispatch(getEditorAPI);

  return {
    openEditorModePanel: () =>
      editorAPI.panelManager.openPanel(
        'panels.focusPanels.mobileFriendlyPanel',
      ),
  };
};
